var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT SERVICES","title":"Student Information System","description":"Manage student profiles, guardian details, promotion and alumni records.","count-label":"student tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }